module.exports = __webpack_public_path__ + "static/VIVAMUS-90716e0d163f1485ff4a79816a0a0508.jpg";